import { render, staticRenderFns } from "./cleancarServiceDetail.vue?vue&type=template&id=00c6a032&scoped=true"
import script from "./cleancarServiceDetail.vue?vue&type=script&lang=js"
export * from "./cleancarServiceDetail.vue?vue&type=script&lang=js"
import style0 from "./cleancarServiceDetail.vue?vue&type=style&index=0&id=00c6a032&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c6a032",
  null
  
)

export default component.exports